import { render, staticRenderFns } from "./assessmentStatistics.vue?vue&type=template&id=2a2c75bd&scoped=true"
import script from "./assessmentStatistics.vue?vue&type=script&lang=js"
export * from "./assessmentStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c75bd",
  null
  
)

export default component.exports